import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "../../hooks/usePagination";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useViewport } from "../../hooks/useViewport";
import { MOBILE_VIEW_ENDPOINT } from "../../constants";
//import "./pagination.scss";
const Pagination = (props: any) => {
  const {
    onPageChange,
    totalCount = [],
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;
  const {sizeInfo,isMobile} = useViewport()
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
    isMobile:( sizeInfo.currentWidth<MOBILE_VIEW_ENDPOINT)
  });
  const location = useLocation()
  
   const [searchParams] = useSearchParams()
   const [oldSearchParams, setOldSearchParams] = useState(searchParams);
   const updatePageInUrl = (page: number) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("currentPage", page.toString());
    setOldSearchParams(newSearchParams)
    navigate(`${location.pathname}?${newSearchParams.toString()}`);
  };

  useEffect(()=>{
    
         
          const getPage = searchParams.get('currentPage')
          if(getPage && oldSearchParams.get('currentPage') !== getPage){
            onPageChange(parseInt(getPage))
          }
  },[searchParams,window.location.search])
   const navigate = useNavigate()
     
  //  useEffect(() => {
  
    
  //     const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  // if (newUrl !== window.location.href) {
  //   navigate(newUrl);
  // }
  //   }, [searchParams,currentPage]);
  const lang = useSelector((state: any) => state?.user?.lang);
  // @ts-ignore
  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
 updatePageInUrl(currentPage +1)
    
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
   
     updatePageInUrl(currentPage - 1);
  };
  // @ts-ignore
  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className="flex justify-between items-center w-full flex-[2]">
    <p className="w-fit min-w-28">{(currentPage-1)*pageSize+1} - {currentPage*pageSize} of {totalCount}</p>
     <ul
      className={classnames("pagination-container ", { [className]: className })}
    >
      <li
        className={classnames("pagination-item flex gap-2 items-center rounded-xl border border-primary", {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className={lang == "ar" ? "arrow right" : "arrow left"} />
        prev
      </li>
      {/* @ts-ignore */}
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <li className="pagination-item dots">&#8230;</li>;
        }

        return (
          <li
            className={classnames("pagination-item min-w-[42px] grid place-content-center rounded-xl", {
              selected: pageNumber === currentPage,
            })}
            onClick={() => {
                updatePageInUrl(pageNumber);
              onPageChange(pageNumber)
            }}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={classnames("pagination-item flex gap-2 items-center rounded-xl  border border-primary", {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        Next
        <div className={lang == "ar" ? "arrow left" : "arrow right"} />
       
      </li>
    </ul>
    </div>
   
  );
};

export default Pagination;
